import { memo } from "react";

import { Chip, Stack, styled } from "@mui/material";
import { ACMG_Criteria } from "@/types/clinvar.model";


const StyledChip = styled(Chip)({
    margin: '2px',
    fontWeight: 500,
    fontSize: '7pt',
    height: '20px',
    '& .MuiChip-label': {
        padding: '0 6px',
    }
    
});
const defaultACMG: ACMG_Criteria = {
    PVS1: "No assertion made",
    PS1: "No assertion made",
    PS2: "No assertion made",
    PS3: "No assertion made",
    PS4: "No assertion made",
    PM1: "No assertion made",
    PM2: "No assertion made",
    PM3: "No assertion made",
    PM4: "No assertion made",
    PM5: "No assertion made",
    PM6: "No assertion made",
    PP1: "No assertion made",
    PP2: "No assertion made",
    PP3: "No assertion made",
    PP4: "No assertion made",
    PP5: "No assertion made",
    BA1: "No assertion made",
    BS1: "No assertion made",
    BS2: "No assertion made",
    BS3: "No assertion made",
    BS4: "No assertion made",
    BP1: "No assertion made",
    BP2: "No assertion made",
    BP3: "No assertion made",
    BP4: "No assertion made",
    BP5: "No assertion made",
    BP6: "No assertion made",
    BP7: "No assertion made"
};


const getACMGCriteria = (acmg: ACMG_Criteria) => {
    const prefixColours: {[key: string]: string} = {
        "P": "error",
        "B": "success",
        "V": "info",
    }

    return Object.entries(acmg).filter(([_key, value]) => value !== 'No assertion made').map(([key, _value]) => ({ label: key, color: prefixColours[key[0]] }));
};




const ACMGChips = memo(({ acmg = defaultACMG }: { acmg?: ACMG_Criteria }) => {
    const criteria = getACMGCriteria(acmg);
    
    return (
        <Stack direction="row" flexWrap="wrap">
            {criteria.map(({ label, color }, index) => (
                <StyledChip
                    key={index}
                    label={label}
                    color={color as any}
                    size="small"
                    variant="outlined"
                />
            ))}
        </Stack>
    );
});

export default ACMGChips;